import React, { useMemo, useState, useEffect } from "react";
import { Plus } from "lucide-react";
import CalendarComponent from "./CalenderComponent";
import LeftSidebar from "./LeftSidebar";
import RightSidebar from "./RightSidebar";
import CreateEventModal from "./CreateEventModal";
import PendingApprovals from "./PendingApprovals";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { useQuery } from "react-query";
import { toast, ToastContainer } from "react-toastify";
import EventDetailsModal from "./EventDetailsModal";
import { Button, Modal, DatePicker } from "antd";
import "../../Styles/eventScheduler.css";
import "../../Styles/overview2.css";
import "../../Styles/overView.css";

const Dashboard = () => {
  const axiosInstance = useAxiosInstance();
  const user = JSON.parse(localStorage.getItem("user"));
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  // const [showCalendarView, setShowCalendarView] = useState( false);
  const [showCalendarView, setShowCalendarView] = useState(
    user?.role === "data_entry_operator"
  );
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [calendarView, setCalendarView] = useState("dayGridMonth");
  const [createEventTab, setCreateEventTab] = useState("visit");
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [calendarPrompt, setCalendarPrompt] = useState({
    visible: false,
    eventId: null,
    eventData: null,
  });

  const { data: dndEntries = [], refetch: refetchDND } = useQuery(
    "DND-List",
    async () => {
      const res = await axiosInstance.get("api/eventScheduler/getDND");
      return res?.data?.data || [];
    }
  );

  const fetchEvents = async () => {
    const response = await axiosInstance.get("api/eventScheduler/events");
    return response.data;
  };

  const { data, isLoading, error, isSuccess, refetch } = useQuery(
    ["Event-List"],
    fetchEvents,
    {
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );
  const events = useMemo(() => {
    if (!data?.status || !data?.data?.events) return [];
    return data.data.events;
  }, [data]);

  const handleCreateEvent = (newEvent) => {
    setIsCreateModalOpen(false);
  };

  const handleDateSelect = (date, startTime, endTime) => {
    setSelectedDate(date);
    setSelectedTime(startTime || "");
    setSelectedEndTime(endTime || "");

    if (startTime || endTime) {
      setIsCreateModalOpen(true);
    }
  };

  const handleSidebarCalendarClick = (date, view) => {
    const formattedDate =
      typeof date === "string" ? date : date.toISOString().split("T")[0];
    setShowCalendarView(true);
    setCalendarView(view);
    setSelectedDate(formattedDate);
  };

  const openCreateEventModalWithTab = (tabName) => {
    setCreateEventTab(tabName);
    setIsCreateModalOpen(true);
  };

  const openEventModal = (eventId) => {
    setSelectedEventId(eventId);
    setIsEventModalOpen(true);
  };

  const closeEventModal = () => {
    setSelectedEventId(null);
    setIsEventModalOpen(false);
  };

  const confirmCalendarSync = async () => {
    const { eventData } = calendarPrompt;

    try {
      const approver = user;
      const attendeesEmails =
        eventData.attendees?.map((a) => a.email).filter(Boolean) || [];

      await axiosInstance.post("api/eventScheduler/add-event-google", {
        eventId: eventData._id,
        title: eventData.eventTitle,
        description: eventData.description,
        start: eventData.start,
        end: eventData.end,
        attendees: attendeesEmails,
        organizerEmail: eventData?.email,
      });

      toast.success("Added to Google Calendar");
    } catch (err) {
      toast.error("Failed to sync with Google Calendar");
    } finally {
      setCalendarPrompt({ visible: false, eventId: null, eventData: null });
    }
  };

  const cancelCalendarSync = () => {
    setCalendarPrompt({ visible: false, eventId: null, eventData: null });
  };

  return (
    <div
      className="min-h-screen dashboard-bg-new pt-4"
    >
      <ToastContainer position="top-right" autoClose={3000} theme="light" />

      <div
        className="px-7 pb-4 overflow-hidden"
        style={{ background: "transparent" }}
      >
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none bg-transparent">
          <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-blue-400/10 to-transparent rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          ></div>
        </div>

        {/* Header */}
        <div
          className="mb-4 flex flex-wrap items-center justify-between gap-4 z-10"
          data-animate
        >
          {/* Hello User Section */}
          <div className="flex-shrink-0">
            <div className="overview-username text-[24px] mb-1">
              Calender Manager
              {/* <span className="username font-semibold">
                {user?.firstName}
              </span> */}
            </div>
            <div className="font-[600] text-[var(--polstrat-primary)] text-sm">
              Plan, organize, and manage all political engagements with ease.
            </div>
          </div>

          {/* Create Event Button */}
          <div className="lang-selector flex">
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              // className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl shadow-lg transition"
                  className="flex items-center justify-center space-x-2 w-full py-3 px-4 text-white rounded-xl shadow-lg transition-all duration-300 transform hover:scale-[1.02] hover:shadow-xl font-medium"
          style={{ 
            backgroundColor: 'var(--polstrat-primary)',
            border: '1px solid var(--polstrat-primary)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#003558';
            e.target.style.borderColor = '#003558';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--polstrat-primary)';
            e.target.style.borderColor = 'var(--polstrat-primary)';
          }}
            >
              <Plus className="w-5 h-5" />
              <span>Create Event</span>
            </Button>
          </div>
        </div>

        {/* Main Dashboard Content */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-8 bg-transparent">
          {/* Left Sidebar */}
          <div className="flex-shrink-0">
            <LeftSidebar
              onCalendarClick={handleSidebarCalendarClick}
              onDNDCreated={refetchDND}
              onScheduleMeetingClick={() =>
                openCreateEventModalWithTab("appointment")
              }
              teamStatus={data?.data?.team}
            />
          </div>

          {/* Main Content */}
          <div className="lg:col-span-2 flex flex-col gap-6">
            {showCalendarView ? (
              <>
                <CalendarComponent
                  dndEntries={dndEntries}
                  initialView={calendarView}
                  events={events}
                  onToggleView={() => setShowCalendarView(false)}
                  onDateSelect={handleDateSelect}
                  selectedDate={selectedDate}
                  refetchDND={refetchDND}
                  onEventClick={openEventModal}
                />
              </>
            ) : (
              <PendingApprovals
                onToggleView={() => setShowCalendarView(true)}
                events={events}
                onEventClick={openEventModal}
                setCalendarPrompt={setCalendarPrompt}
              />
            )}
          </div>

          {/* Right Sidebar */}
          <div className="flex-shrink-0">
            <RightSidebar
              overview={data?.data?.overview}
              quickStats={data?.data?.stats}
              todaysSchedule={data?.data?.todaysSchedule}
              onEventClick={openEventModal}
              events={events}
            />
          </div>
        </div>
      </div>

      {/* Create Event Modal */}
      <CreateEventModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onCreateEvent={handleCreateEvent}
        selectedDate={selectedDate}
        selectedStartTime={selectedTime}
        selectedEndTime={selectedEndTime}
        dndEntries={dndEntries}
        onDNDCreated={refetchDND}
        initialTab={createEventTab}
      />
      <EventDetailsModal
        isOpen={isEventModalOpen}
        eventId={selectedEventId}
        onClose={closeEventModal}
      />
      {calendarPrompt.visible && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg p-6 w-96 text-center space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">
              Add to Google Calendar?
            </h3>
            <p className="text-sm text-gray-600">
              Do you want to add this{" "}
              {calendarPrompt.eventData?.typeOfEvent || "event"} to your Google
              Calendar?
            </p>
            <div className="flex justify-center gap-4 mt-4">
              <button
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                onClick={confirmCalendarSync}
              >
                Yes
              </button>
              <button
                className="px-4 py-2 rounded bg-gray-300 text-gray-800 hover:bg-gray-400"
                onClick={cancelCalendarSync}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
